import Overview from "@/components/admin/Content/WebPages/AboutUs/LegalFoundation/Overview";
import HeroSection from "@/components/admin/Content/WebPages/AboutUs/LegalFoundation/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const LegalFoundation = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <HeroSection data={pageData?.LEGAL_FOUNDATION_BANNER ?? {
        sectionTag: 'LEGAL_FOUNDATION_BANNER',
        contentType: 'WITH_FILE',
        title: 'Legal Foundations Banner'
      }} />
      <Overview data={pageData?.LEGAL_FOUNDATION ?? {
        sectionTag: 'LEGAL_FOUNDATION',
        contentType: 'WITHOUT_FILE',
        title: 'Legal Foundations'
      }} />
    </div>
  )
}

export default LegalFoundation